export const PREVIEW_MODE = "preview";
export const EXTENDED_PREVIEW_MODE = "extended-preview";
export const SPECTATOR_MODE = "spectator";
export const FULL_MODE = "full";

/**
 * Preview mode - user is able only to observe StackViz, no interactions available
 * Extended preview mode - user is able only to observe StackViz, has zoom controls and the option to select component and execute custom function on clicked component
 * Spectator mode - user is able only to observe StackViz, interactions to change the StackViz is not allowed
 * Full mode - user is able to do everything with StackViz
 */
export type StackVizMode =
	| typeof PREVIEW_MODE
	| typeof EXTENDED_PREVIEW_MODE
	| typeof SPECTATOR_MODE
	| typeof FULL_MODE;

export const isPreviewMode = (mode: StackVizMode): mode is typeof PREVIEW_MODE => mode === PREVIEW_MODE;

export const isExtendedPreviewMode = (mode: StackVizMode): mode is typeof EXTENDED_PREVIEW_MODE =>
	mode === EXTENDED_PREVIEW_MODE;

export const isInteractionMode = (mode: StackVizMode): boolean => !(isPreviewMode(mode) || isExtendedPreviewMode(mode));

export const isComponentSelectMode = (mode: StackVizMode): boolean => isExtendedPreviewMode(mode);
